export default {
  paths: {
    users: {
      prefix: 'user_requests',
      uris: {
        login: 'login',
        logout: 'logout',
        getUsers: 'get_users',
        getGroups: 'get_groups',
        getGroupsSelect: 'get_groups_select',
        createGroup: 'creategroup',
        createUser: 'createuser',
        getGroup: 'get_group',
        userForKey: 'user_for_key',
        register: 'activateuser',
        saveGroup: 'creategroup',
        deleteGroups: 'delete_groups',
      },
    },
    clients: {
      prefix: 'clients',
      uris: {
        getClients: 'get_clients',
        setClient: 'set_client',
        getClientParams: 'get_client',
        deleteClients: 'delete_clients',
        setStartDebt: 'set_start_debt',
      },
    },
    expenses: {
      prefix: 'expenses',
      uris: {
        getExpenses: 'get_expenses',
        registerExpense: 'register_expense',
        getExpenseParams: 'get_expense_params',
        deleteExpenses: 'delete_expenses',
        generateSalaryCheckes: 'generate_salary_checkes',
        getClientAccountingParams: 'get_client_accounting_params',
        getOutPayments: 'get_out_payments',
        getExpenseGroups: 'get_expense_groups',
      },
    },
    offers: {
      prefix: 'submit_offer_info',
      uris: {
        submitOfferInfo: 'main',
        saveOffer: 'save_offer',
        generateConfirmedOffers: 'generate_confirmed_offers',
        deleteOffer: 'deletecachedoffer',
        deleteOffers: 'delete_offers',
        downloadInvoice: 'create_invoice',
        createOfferLog: 'create_offer_log',
        getOfferLogPdf: 'get_offer_log_pdf',
        getContactPerson: 'getcontactpersons',
        setPaid: 'set_paid',
        setInvoicesPaid: 'set_invoices_paid',
        getOfferLogs: 'get_offer_logs',
        convertInvoices: 'convert_invoices',
        linkOffers: 'link_offers',
        splitOffers: 'split_offers',
      },
    },
    job: {
      prefix: 'submit_job_info',
      uris: {
        jobPriceCalculations: 'main',
        bindingOptional: 'binding',
        bindingPrep: 'binding_prep',
        editCachedJob: 'editjob',
        finishJob: 'finish_job',
        removeJob: 'remove_job',
        cancelJob: 'cancel_job',
        getBindingParam: 'get_binding_parameters',
        getBindingTable: 'get_binding_table',
        setBindingId: 'set_binding',
        jobTotalDiscount: 'set_job_total_discount',
      },
    },
    item: {
      prefix: 'submit_for_item_pricing',
      uris: {
        jobItemPriceCalculation: 'main',
        jobItemOptional: 'optional',
        finishItem: 'finishitem',
        editCachedItem: 'edititem',
        removeItem: 'removeitem',
        cancelItem: 'cancel_item',
        getTheTotalPrice: 'get_item_total',
        getItemParams: 'get_item_params',
        getItemTable: 'get_item_table',
      },
    },
    miscellaneous: {
      prefix: 'submit_miscellaneous_material_info',
      uris: {
        getMiscellaneousItems: 'get_miscellaneous_items',
        getMiscellaneousItemsCard: 'get_card',
      },
    },
    largeFormat: {
      prefix: 'submit_large_format_info',
      uris: {
        getLargeFormats: 'get_large_format_items',
        getLargeFormatCard: 'get_card',
        startLargeFormatJob: 'start',
        finishLargeFormatJob: 'finish',
      },
    },
    payments: {
      prefix: 'payments',
      uris: {
        getPayments: 'get_payments',
        setPayment: 'set_payment',
        getPayment: 'get_payment',
        deletePayments: 'delete_payments',
        generatePayments: 'generate_payments',
      },
    },
    invoices: {
      prefix: 'invoices',
      uris: {
        getInvoices: 'get_invoices',
        deleteInvoices: 'delete_invoices',
        sendForVat: 'send_for_vat',
        cancelInvoice: 'cancel_invoice',
        getQrCodeUrl: 'get_qr_code',
        getInvoice: 'get_invoice',
        getInvoiceBody: 'download_invoice',
        saveInvoice: 'save_invoice',
        calculateInvoice: 'calculate_invoice',
      },
    },
    itemCount: {
      prefix: 'item_count',
      uris: {
        getSpirals: 'get_spirals',
        getSpiral: 'get_spiral',
        setSpiral: 'set_spiral',
        deleteSpirals: 'delete_spirals',
        getMaterialCount: 'get_materials',
        getPapers: 'get_papers',
        getPaper: 'get_paper',
        setPaper: 'set_paper',
        deletePapers: 'delete_papers',
        resetInventory: 'reset_item_count',
        setManualMaterialInput: 'set_manual_material_input',
        getManualMaterialInputs: 'get_manual_material_inputs',
      },
    },
    transactions: {
      prefix: 'transactions',
      uris: {
        getTransactions: 'get_transactions',
        makeTransfer: 'make_transaction',
      },
    },
    _: {
      uris: {
        getFormats: 'get_formatsSt',
        paperTypes: 'get_papertypesSt',
        getMachines: 'get_machines',
        getJobTypes: 'get_jobtypes',
        getColorPalettes: 'get_colorpalettes',
        getClient: 'get_clients',
        getBindingTypes: 'get_bindingtypes',
        cachingTypes: 'get_cachingpapers',
        getJobs: 'get_jobs',
        getOffers: 'get_offers',
        getOfferGroups: 'get_offer_groups',
        getOffer: 'get_offer',
        checkSession: 'checksession',
        getUsersSelect: 'get_users',
        getPaperGroups: 'get_paper_groups',
        getSession: 'get_session',
        getExpenseTypes: 'get_expensetypes',
        getMaterialTypes: 'get_materialtypes',
        getMaterials: 'get_materials',
        getMiscellaneousMaterials: 'get_other_materials',
        getShifts: 'get_shifts',
        getBankAccounts: 'get_bank_accounts',
        getItemUnits: 'get_item_units',
        printTable: 'print_table',
        getCountries: 'get_countries',
        getPaperFormats: 'get_paper_formats',
      },
    },
  },
  extension: 'php',
};
